import { render, staticRenderFns } from "./webForensicsUp.vue?vue&type=template&id=f452ce52&scoped=true&"
import script from "./webForensicsUp.vue?vue&type=script&lang=js&"
export * from "./webForensicsUp.vue?vue&type=script&lang=js&"
import style0 from "./webForensicsUp.vue?vue&type=style&index=0&id=f452ce52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f452ce52",
  null
  
)

export default component.exports